import PaymentFilters from './PaymentFilters.container';

export default PaymentFilters;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/PaymentFilters/index.js